import { store } from '../store/stencil-redux';
import { loadApp } from "../store/app/app.actions";
import { getAppForms, getAppId, getApps } from "../store/selectors";
import SQLDatabase from "./db/sql.service";
import { startForm } from "./forms.service";
import MapService from "./maps.service";
import { presentRecordModal } from "./records.service";

type StabilityTestAction = () => Promise<void>;

export default class StabilityTestService {

  private constructor() { }

  public static instance: StabilityTestService = new StabilityTestService();
  private sleepInterval: number = 1000;
  private running: boolean = false;

  private delay(t: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, t));
  }

  private random(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  private randomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min + 1)) + min;
  }


  async switchApp() {
    const s = store.getStore();
    const state = store.getState();
    const apps = getApps(state);
    const appId = getAppId(state);
    const currentIdx = apps.findIndex(app => app.id === appId);
    const nextAppIdx = currentIdx === apps.length - 1 ? 0 : currentIdx + 1;
    const nextApp = apps[nextAppIdx];

    return loadApp(nextApp.id, false)(s.dispatch, s.getState.bind(s));
  };

  syncApp() {
    // const appId = getAppId(store.getState());
    // return AppService.instance.syncModal({
    //   projectId: appId
    // });
  }

  async moveMap() {
    // const map = await mapEl.getMap();
    const map = MapService.instance.getMap();
    const center = map.getCenter();

    map.easeTo({
      center: [
        center.lng + this.random(-1, 1),
        center.lat + this.random(-1, 1)
      ],
      zoom: this.randomInt(5, 18)
    });
  }

  async openRecord() {
    const appId = getAppId(store.getState());
    const result = await SQLDatabase.instance.query<{ id: number }>(`SELECT id FROM records WHERE projectId = ${appId} ORDER BY RANDOM() LIMIT 1`);
    const modal = await presentRecordModal(result[0].id);
    await this.delay(3000);
    return modal.dismiss();
  }

  async openForm() {
    const formId = getAppForms(store.getState())[0].id;
    const modal = await startForm(formId, null);
    await this.delay(3000);
    return modal.dismiss();
  }

  public async run() {

    if (this.running) {
      this.running = false;
      return;
    }

    this.running = true;

    const actions: StabilityTestAction[] = [
      // this.switchApp.bind(this),
      // this.syncApp.bind(this),
      // this.moveMap.bind(this),
      // this.openRecord.bind(this),
      this.openForm.bind(this)
    ];
    await this.delay(this.sleepInterval);

    while (this.running) {
      const action = actions[Math.floor(Math.random() * actions.length)];
      await action();
      await this.delay(this.sleepInterval);
    }
  }

  private click(selector: string) {
    return this.clickElement(document.querySelector(selector) as HTMLElement);
  };

  private clickElement(element: HTMLElement) {
    element.click();
    return new Promise(resolve => setTimeout(resolve, this.sleepInterval));
  };

  private async openAndCloseForms() {
    await this.click('#records-fab-button-add');
    await this.click('#records-forms-modal-close-button');

  }

  private getActiveFormModal(){
    return document.querySelector('ion-modal.form-modal--container.show-modal:last-child');
  }

  public async runUKHab() {

    await this.click('#records-fab-button-add');
    // If i is even, close, else open form
    // Open UKHab
    await this.click('.form-card:nth-child(2)');

    // Press Next
    await this.click('#form-next-button');

    // Click the L1
    await this.click('.select-mock');

    // Select one
    await this.click('coreo-collection-list-item');

    // Press Next
    await this.click('#form-next-button');
    await this.click('#form-next-button');

    // Quadrats
    const numQuadrats = 2;
    for (let i = 0; i < numQuadrats; i++) {
      await this.click('record-attribute-edit .form-association--another');
      // Click quadrats option
      await this.click('coreo-checkmark');

      // Find the text block and enter some text
      const input = document.querySelector('#record-attribute-edit-1204107 ion-input') as HTMLIonInputElement;
      input.value = (i +1).toString();
      input.dispatchEvent(new Event('keyup'));
      await this.delay(1000);

      // Get the species modal
      const quadratModal = this.getActiveFormModal();
      await this.clickElement(quadratModal.querySelector('#form-next-button') as HTMLElement);

      // Now we need to click on the map somehow
      const map = quadratModal.querySelector('coreo-mapbox-map') as HTMLCoreoMapboxMapElement
      const center = await map.getCenter();
      // Fire the geometry event
      const geometrySelector = quadratModal.querySelector('app-geometry-selector') as HTMLAppGeometrySelectorElement;
      // Adjust the lat and lng slightly so they aren't always on top of each other
      const xVar = Math.random() * 0.01;
      const yVar = Math.random() * 0.01;
      geometrySelector.emitGeometryChange({
        type: 'Point',
        coordinates: [center.lng + xVar, center.lat + yVar]
      });
      await this.delay(1000);
      await this.clickElement(quadratModal.querySelector('#form-next-button') as HTMLElement);

      // Click to open the species modal
      const speciesButton = quadratModal.querySelector('#record-attribute-edit-1204109 .form-association--another');
      await this.clickElement(speciesButton as HTMLElement);

      // Get the species modal
      const quadratSpeciesModal = this.getActiveFormModal();
      await this.clickElement(quadratSpeciesModal.querySelector('.select-mock') as HTMLElement);
      await this.click('coreo-collection-list-item[ik="sp9"]');
      await this.clickElement(quadratSpeciesModal.querySelector('#form-next-button') as HTMLElement);

      // Finish the quadrat
      await this.clickElement(quadratModal.querySelector('#form-next-button') as HTMLElement);
    }

    // General Species
    const numSpecies = 2;
    for (let i = 0; i < numSpecies; i++) {
      await this.click('record-attribute-edit:last-child .form-association--another');
      await this.click('#record-attribute-edit-1203661 .select-mock');
      const speciesId = `sp${i + 1}`;
      await this.click(`coreo-collection-list-item[ik="${speciesId}"]`);

      // Get the species modal
      const speciesModal = document.querySelector('ion-modal.form-modal--container:last-child');
      await this.clickElement(speciesModal.querySelector('#form-next-button') as HTMLElement);
      await this.clickElement(speciesModal.querySelector('#form-next-button') as HTMLElement);
    }


    // Back in the main form, now go forward and save
    await this.click('#form-next-button');
    await this.click('#form-next-button');
    await this.click('#form-save-button');
    await this.click('#form-exit-button');
  }

  public async profile(count: number = 50) {
    if (this.running) {
      this.running = false;
      return;
    }
    this.running = true;
    for (let i = 0; i < count; i++) {
      if (!this.running) {
        return;
      }
      // If i is even, close, else open form
      if (i % 2 === 0) {
        await this.openAndCloseForms();
      } else {
        await this.runUKHab();
      }
    }
    this.running = false;
  }
}
(window as any).doProfiling = StabilityTestService.instance.profile.bind(StabilityTestService.instance);
(window as any).runUKHab = StabilityTestService.instance.runUKHab.bind(StabilityTestService.instance);
